// import React from "react";
// import ReactDOM from "react-dom";
// import App from "./App";
// import "./index.css";
// import { Provider } from "react-redux";
// import store from "./redux/storeConfig";

// ReactDOM.render(
//   <Provider store={store()}>
//     <App />
//   </Provider>,
//   document.getElementById("root")
// );


// import React from "react";
// import ReactDOM from "react-dom";
// import { Provider } from "react-redux";
// import { PersistGate } from "redux-persist/integration/react";
// import ConfigureStore from "../src/redux/storeConfig";
// import App from "./App"; // Your main application component
// import "./index.css";

// // Get the store and persistor from the configured store function
// const { store, persistor } = ConfigureStore();

// ReactDOM.render(
//   <Provider store={store}>
//     {/* PersistGate delays the rendering of your app until the persisted state has been rehydrated */}
//     <PersistGate loading={null} persistor={persistor}>
//       <App />
//     </PersistGate>
//   </Provider>,
//   document.getElementById("root")
// );


import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import ConfigureStore from "./redux/storeConfig";
import App from "./App";
import "./index.css";
import { checkAndHandleRefreshLoop, resetRefreshCounter } from "./utils/refreshLoopDetector";

// Check for infinite refresh loop BEFORE initializing React
// If loop is detected, data will be cleared and page will reload
if (checkAndHandleRefreshLoop()) {
  // If refresh loop was detected, the function will reload the page
  // This code won't execute, but we keep it for clarity
  console.log("Refresh loop detected, clearing data and reloading...");
}
// Note: Refresh counter will be reset in App.js after successful mount

// Get configured store & persistor
const { store, persistor } = ConfigureStore();

ReactDOM.render(
  <Provider store={store}>
    {/* PersistGate waits for rehydration of persisted slices */}
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

